import { useQuery } from '@tanstack/react-query';
import { type AdviceDto } from '../types';

export function useGetAdvice(dataUploadFileId?: string) {
  const { data, isLoading, error, refetch } = useQuery<AdviceDto[]>({
    queryKey: ['advice', dataUploadFileId],
    enabled: !!dataUploadFileId,
  });

  return {
    advice: data ?? [],
    isLoading,
    error,
    refetch,
  };
}
